export const formatServerError = (
  error: string | null,
  fieldName?: string
): string => {
  if (!error) return ''

  return fieldName || error
}
